export const storageKey = "lulu-regional-weather-data";
export const personalizationWeatherHost = "personalizationWeatherHost";
